import { openPluginModalPage } from 'actions/modalPage';
import { modals } from 'plugins/mm/constants';
import { GridButtonFunction } from 'reducers/UI/gridButtons';

export const customerServiceButton = {
  id: 'customerService',
  actionType: 'action',
  action: openPluginModalPage(modals.CUSTOMER_SERVICE)({
    isPopup: true,
  }),
} as GridButtonFunction;
